import type { Ingredient } from '@awwyeah/shared';
import { parseIngredientLine } from './parseIngredientLine';

/**
 * Display-time safety net for text-only ingredients (URL imports and bulk imports save
 * raw lines; only manually-edited rows get parsed as you type). Scaling/conversion needs
 * `quantity`/`unit` — derive them on the fly when absent so every recipe scales, without
 * mutating stored data. A line the parser can't read comes back unchanged, and
 * `scaleIngredientForDisplay` then falls back to showing `text` verbatim as before.
 */
export function ensureStructured(ing: Ingredient): Ingredient {
  if (ing.quantity || ing.unit) return ing;
  const p = parseIngredientLine(ing.text);
  if (!p.quantity && !p.unit) return ing;
  return { ...ing, quantity: p.quantity, unit: p.unit, name: p.name };
}
